/**
 * This module exists to help us prepare for all kinds of logging behaviour, amongst which:
 * - automated reports sent to us
 * - error logs for configurators
 */

/**
 * This prepares us to eventually have automated reports sent to us
 */
export function logErrorAndEventuallyReportToBimBamBoom(...xs: any[]) {
  console.error(...xs)
}
